module.exports = __webpack_public_path__ + "img/index-svg-black-en.2b75bad8.svg";